/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StationaryUnitType } from './StationaryUnitType';
import {
    StationaryUnitTypeFromJSON,
    StationaryUnitTypeFromJSONTyped,
    StationaryUnitTypeToJSON,
    StationaryUnitTypeToJSONTyped,
} from './StationaryUnitType';

/**
 * 
 * @export
 * @interface StationaryUnitCreate
 */
export interface StationaryUnitCreate {
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitCreate
     */
    label: string;
    /**
     * The stationary unit's serial number.
     * 
     * This is expected to be unique
     * @type {string}
     * @memberof StationaryUnitCreate
     */
    serialNumber: string;
    /**
     * 
     * @type {StationaryUnitType}
     * @memberof StationaryUnitCreate
     */
    stationaryUnitType: StationaryUnitType;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitCreate
     */
    hardwareKey: string;
    /**
     * 
     * @type {Date}
     * @memberof StationaryUnitCreate
     */
    firmwareLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnitCreate
     */
    firmwareCurrentVersion: string;
}



/**
 * Check if a given object implements the StationaryUnitCreate interface.
 */
export function instanceOfStationaryUnitCreate(value: object): value is StationaryUnitCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('stationaryUnitType' in value) || value['stationaryUnitType'] === undefined) return false;
    if (!('hardwareKey' in value) || value['hardwareKey'] === undefined) return false;
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('firmwareCurrentVersion' in value) || value['firmwareCurrentVersion'] === undefined) return false;
    return true;
}

export function StationaryUnitCreateFromJSON(json: any): StationaryUnitCreate {
    return StationaryUnitCreateFromJSONTyped(json, false);
}

export function StationaryUnitCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'serialNumber': json['serialNumber'],
        'stationaryUnitType': StationaryUnitTypeFromJSON(json['stationaryUnitType']),
        'hardwareKey': json['hardwareKey'],
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'firmwareCurrentVersion': json['firmwareCurrentVersion'],
    };
}

export function StationaryUnitCreateToJSON(json: any): StationaryUnitCreate {
    return StationaryUnitCreateToJSONTyped(json, false);
}

export function StationaryUnitCreateToJSONTyped(value?: StationaryUnitCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'serialNumber': value['serialNumber'],
        'stationaryUnitType': StationaryUnitTypeToJSON(value['stationaryUnitType']),
        'hardwareKey': value['hardwareKey'],
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'firmwareCurrentVersion': value['firmwareCurrentVersion'],
    };
}

